/**
 * Function to fetch the history from the localstorage
 */
function fetchHistory() {
  return localStorage.getItem("searchHistory");
}

/**
 * Function to write the history to local storage
 * @param {String} data
 */
function dumpHistoy(data) {
  localStorage.setItem("searchHistory", data);
}

/**
 * Removes the histoy registry in localstorage
 */
function removeHistory() {
  localStorage.removeItem("searchHistory");
}

export { fetchHistory, dumpHistoy, removeHistory };
